import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { message, Modal } from 'antd';
import BatchRelate from './components/BatchRelate';
import Filter from './components/Filter';
import Hospital from './components/Hospital';
import List from './components/List';
import RelateJdeCode from './components/RelateJdeCode';
import Update from './components/Update';
import Sider from '../SiteSider';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import { actions } from '../../../actions/researchCenter/detail';

class ResearchCenterDetail extends Component {
    static childContextTypes = {
        curRole: PropTypes.string,
        roleAuth: PropTypes.bool,
        isConfig: PropTypes.bool,
        isCompleted: PropTypes.bool,
        contractList: PropTypes.array,
    }

    constructor(props) {
        super(props);
        const { searchParams } = props;
        this.state = {
            loading: false,
            visible: false,
            pagination: {
                pageSize: 10,
                current: 1,
            },
            data: [],
            searchParams: {...searchParams},
            sortParams: {},
            contractList: [],
            beforeStartInvDatas:{}
        };
    }

    getChildContext = () => {
        const curRole = this.curRole;
        const roleAuth = curRole == "PA" || curRole == "PM" || curRole == "CTA";
        const { contractList } = this.state;
        return {
            curRole,
            roleAuth,
            isConfig: this.isConfig,
            isCompleted: this.isCompleted,
            contractList,
        };
    }

    init = () => {
        const { curRole, invState, invStatus } = sessionStorage;
        this.curRole = curRole;
        this.isConfig = invState == 3;
        this.isCompleted = invStatus === 'COMPLETED';
    }

    componentDidMount() {
        this.init();
        this.loadData();
        this.queryContract();
        this.queryInvBeforeStartIsExists();
        this.querySignedContractWithNoSite();
    }

    // 判断是否设置配套启动前项目
    queryInvBeforeStartIsExists = () =>{
        const options = {
            url: API_URL.site.queryInvBeforeStartIsExists,
            data: {
            },
            dataType: 'json',
            doneResult: res => {
                const {datas = {}} = res;
                this.setState({beforeStartInvDatas:datas});
            },
            errorResult: (err) => {
                message.error(err)
            },
        };
        $.sendRequest(options);
    }

    // 判断是否有签署完成合同没有关联中心
    querySignedContractWithNoSite = () => {
        const { invState } = sessionStorage;
        const options = {
            url: API_URL.site.querySignedContractWithNoSite,
            data: {
            },
            dataType: 'json',
            doneResult: res => {
                const { codes } = res;
                this.setState({ 
                    codes,
                    visible: invState == '3' && codes && codes !== ''
                })
            },
            errorResult: (err) => {
                message.error(err)
            },
        };
        $.sendRequest(options);
    }

    componentWillUnmount() {
        this.props.clearSearchParams();
    }

    loadData = () => {
        const { pagination, searchParams, sortParams } = this.state;
        const { current, pageSize } = pagination;

        this.setState({ loading: true });
        const options = {
            url: API_URL.site.list,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
                ...sortParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { siteList } = res.data;
                const { datas: data, totalCount } = siteList || {};
                pagination.total = totalCount;
                this.setState({
                    data,
                    pagination,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    queryContract = () => {
        const options = {
            url: API_URL.site.queryAllInvestigationJdeContract,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({ contractList: res.data });
            }
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    omit = investigationSiteId => {
        Modal.confirm({
            iconType: 'exclamation-circle',
            title: '确定要删除吗？',
            onOk: () => {
                this.setState({ loading: true });
                $.sendRequest({
                    url: API_URL.site.delSite,
                    data: { investigationSiteId },
                    dataType: 'json',
                    doneResult: () => {
                        this.setState({ loading: false }, () => {
                            this.loadData();
                        });
                    },
                    errorResult: () => {
                        this.setState({ loading: false });
                    }
                });
            }
        });
    }

    handleTableChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    showHospital = id => {
        this.hospitalRef.show(id);
    }

    batch = () => {
        this.batchRef.show();
    }

    update = (record, type) => {
        this.updateRef.show(record, type);
    }

    relate = (record) => {
        const { contractVos, investigationSiteId } = record;
        this.relateRef.show(contractVos, investigationSiteId);
    }

    handleOk = () => {
        this.handleCancel()
        this.batch()
    }

    handleCancel = () => {
        this.setState({ visible: false })
    }

    render() {
        const { data, loading, pagination, searchParams, sortParams ,beforeStartInvDatas, visible, codes } = this.state;
        return (
            <div className="content">
                <Sider selectKey='site'/>
                <div className="main">
                    {
                        this.isConfig &&
                        <Filter
                            loading={loading}
                            batch={this.batch}
                            update={this.update}
                            search={this.search}
                            searchParams={searchParams}
                        />
                    }
                    <List
                        data={data}
                        loading={loading}
                        pagination={pagination}
                        sortParams={sortParams}
                        omit={this.omit}
                        onChange={this.handleTableChange}
                        showHospital={this.showHospital}
                        update={this.update}
                        relate={this.relate}
                    />
                </div>
                <BatchRelate ref={el => this.batchRef = el} loadData={this.loadData} />
                <RelateJdeCode ref={el => this.relateRef = el} loadData={this.loadData} />
                <Update ref={el => this.updateRef = el } loadData={this.loadData}  beforeStartInvDatas={beforeStartInvDatas}/>
                <Hospital ref={el => this.hospitalRef = el } />
                <Modal
                    title={'未关联中心的合同信息确认'}
                    visible={visible}
                    onOk={this.handleOk}
                    width={360}
                    onCancel={this.handleCancel}
                >
                    <p>{`JDE项目号：${codes}未有中心与之关联，请及时进行关联`}</p>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    ...state.researchCenter.detail
});

export default connect(mapStateToProps, actions)(ResearchCenterDetail);


// WEBPACK FOOTER //
// ./src/components/site/researchCenterDetail/index.js